import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { Icon } from "../../icon/Icon";
import { openRemoveModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useRemoveDeviceMenuItem = (deviceName, deviceId) => {
  const dispatch = useDispatch();

  return {
    id: "remove",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-times" />
        <span>
          <FormattedMessage id="remove" />
        </span>
      </Fragment>
    ),
    action: () => dispatch(openRemoveModal(deviceName, deviceId)),
  };
};

export const RemoveDeviceDropdownItem = ({
  deviceName,
  logicalDeviceId,
  ...props
}) => {
  const { id, content, action } = useRemoveDeviceMenuItem(
    deviceName,
    logicalDeviceId
  );

  return (
    <LazyLoadDropdownItem id={id} action={action} {...props}>
      {content}
    </LazyLoadDropdownItem>
  );
};

export const RemoveDeviceModalItem = ({ deviceName, logicalDeviceId }) => {
  const { id, content, action } = useRemoveDeviceMenuItem(
    deviceName,
    logicalDeviceId
  );

  return (
    <DeviceActionsModalItem id={id} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
